import { Controller, ControllerRenderProps, FieldValues, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Textarea } from '@components/textarea';
import { Admission } from '@domain/admission';
import { CompanyRoles } from '@domain/company';
import { Invitation } from '@domain/invitation';
import { validateMultiInviteText } from '@utils/validations/validate-multi-invite-text';

export const ControllerMultiTextArea = ({
  textareaPlaceholder,
  formName,
  offer,
  roleName,
  enforceQuantityOne,
  enforceEmailRequired,
  triggerValidation,
}: {
  textareaPlaceholder: string;
  formName: string;
  offer?: Admission | Invitation;
  roleName?: CompanyRoles;
  enforceQuantityOne?: boolean;
  enforceEmailRequired?: boolean;
  triggerValidation?: (fieldName?: string) => Promise<boolean>;
}) => {
  const { t } = useTranslation();
  const { control, setValue } = useFormContext();

  const handleBlur = async (field: ControllerRenderProps<FieldValues, string>) => {
    field.onBlur();
    const value = field.value as string;

    // If manual validation is enabled and there's content, trigger validation
    if (triggerValidation && value && value.trim().length > 0) {
      await triggerValidation(formName);
    }
  };

  return (
    <Controller
      rules={{
        required: t('errors:formFieldRequired'),
        validate: (v: string) => {
          return validateMultiInviteText({
            value: v,
            t,
            offer,
            setValue,
            roleName,
            enforceQuantityOne,
            enforceEmailRequired,
          });
        },
      }}
      render={({ field }) => (
        <Textarea
          className='min-h-28 px-3 py-2 text-sm placeholder:opacity-70'
          onChange={field.onChange}
          onBlur={() => handleBlur(field)}
          placeholder={textareaPlaceholder}
        />
      )}
      name={formName}
      control={control}
    />
  );
};
